/**
 * @ngdoc directive
 * @name WcResponsiveTableModule.directive:wcRowActionSingle
 * @restrict A
 * @scope
 * @param {string} wcRowActionSingle The parameter holds the single row action values
 * @description
 * The wcRowActionSingle directive is responsible for the single row actions that are carried out in the datatable.
 */



angular.module('WcResponsiveTableModule').directive('wcRowActionSingle', function() {
	return {
		restrict: 'A',
		require: ['wcRowActionSingle', '^wcResponsiveTable'],
		scope: {},
		bindToController: {
			wcRowActionSingle: '@'
		},
		controllerAs: 'rowActionSingleController',
		controller: ['$scope', '$element', function ($scope, $element) {
			var responsiveTableController = $element.parent().controller('wcResponsiveTable');

			this.singleAction = function() {
				var rowScope = $scope.$parent;
				var viewScope = responsiveTableController.WcTableScopeService.getParentScope();

				var data = [].concat(rowScope.rowKey);

				viewScope.$broadcast(this.wcRowActionSingle, data);
			};
		}],
		link: function (scope, element, attrs, controllers) { //jshint unused:true
			var rowActionSingleController = controllers[0];

			element.on('click', function() {
				rowActionSingleController.singleAction();
			});
		}
	};
});